var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87856 12.3789L8.79131 14.8404H9.26494L13.1147 12.3789L12.5151 11.9058L9.01237 14.1462L5.38369 11.9058L4.87856 12.3789ZM6.77194 6.6678L8.98088 3.32261L11.2528 6.6993L11.7894 6.22567L9.26494 2.43948C9.26494 2.43948 9.04388 2.15542 8.69681 2.43948L6.10931 6.32073L6.77194 6.6678Z",
    fill: "white",
    fillOpacity: 0.703
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04388 13.4206C9.16988 12.9785 9.32794 12.5685 9.4545 12.1269C10.0226 10.3595 10.5902 8.56065 11.1583 6.79384C11.1898 6.69934 11.2213 6.57277 11.2528 6.47884C11.3158 6.28871 11.4103 6.19421 11.5999 6.19421C11.6822 6.19204 11.7625 6.21954 11.8262 6.27169C11.89 6.32384 11.9328 6.39716 11.9469 6.47827C12.1044 7.1094 12.231 7.77202 12.3885 8.40315C12.6726 9.6024 12.9251 10.8331 13.2092 12.0318C13.2722 12.3159 13.1777 12.5055 12.9566 12.5685C12.7356 12.6315 12.5781 12.474 12.5151 12.1899C12.1995 10.8331 11.8839 9.47584 11.5999 8.08759C11.5999 8.02459 11.5684 7.99309 11.5369 7.89802C11.5107 7.98436 11.4789 8.06891 11.4418 8.15115C10.8428 9.98096 10.2746 11.8113 9.675 13.6411C9.5805 13.9882 9.45394 14.3038 9.35944 14.6508C9.29644 14.8719 9.16988 14.9664 8.98088 14.9664C8.79131 14.9664 8.66531 14.8719 8.60231 14.6514C7.90819 12.474 7.2135 10.2965 6.55088 8.11909C6.51938 8.05609 6.51938 8.02459 6.48788 7.89802C6.43159 8.18353 6.36857 8.46767 6.29888 8.75021C6.04575 9.88646 5.79375 11.0536 5.54119 12.1899C5.47819 12.5049 5.22619 12.663 4.97306 12.5049C4.81556 12.4104 4.78406 12.2529 4.81556 12.0633C5.16263 10.4855 5.54119 8.90771 5.88825 7.33046C5.95125 7.07734 6.01481 6.82534 6.04575 6.57277C6.10931 6.32077 6.23531 6.19421 6.42488 6.19421C6.61444 6.19421 6.73988 6.32077 6.80344 6.57277C7.52906 8.84527 8.25469 11.1487 8.94938 13.4206H9.04388Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetone);
export default __webpack_public_path__ + "static/media/meetone.0a415a90d9487dcc3dcfbdc6581cefff.svg";
export { ForwardRef as ReactComponent };